import cn from 'classnames';

export const PaymentBalanceHistoryCell = ({ title, className }: { title: string | number; className?: string }) => {
  return <span className={cn('payment-balance-history-cell', className)}>{title}</span>;
};

